import { render, staticRenderFns } from "./PurchaseGain.vue?vue&type=template&id=6d16092d&scoped=true&"
import script from "./PurchaseGain.vue?vue&type=script&lang=js&"
export * from "./PurchaseGain.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseGain.vue?vue&type=style&index=0&id=6d16092d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d16092d",
  null
  
)

export default component.exports